import {
  ChartMark,
  WidgetKind,
  type Filters,
  type Report,
  type WidgetOf,
} from 'corso-admin-ui';
import { isProtected, notProtected } from './filters';

const shippingRevenue = (orders: string, filters: Filters<'orders'>) =>
  [
    {
      kind: WidgetKind.kpi,
      title: `Shipping revenue (${orders})`,
      metric: 'shippingCharged',
      filters,
    },
    {
      kind: WidgetKind.kpi,
      title: `Average shipping revenue (${orders})`,
      metric: 'avgShippingCharge',
      filters,
    },
  ] as const satisfies WidgetOf<'orders'>[];

export const shippingLines = {
  key: 'shippingLines',
  label: 'Shipping Lines',
  dataset: 'orders',
  timeFields: ['orderedOn'],
  widgets: [
    ...shippingRevenue('not protected', notProtected),
    ...shippingRevenue('protected', isProtected),
    {
      kind: WidgetKind.overTime,
      title: 'Shipping revenue over time',
      mark: ChartMark.line,
      metrics: ['shippingCharged'],
    },
    {
      kind: WidgetKind.table,
      title: 'Orders by shipping method',
      dimensions: ['shippingTitle'],
      metrics: ['orders', 'shippingCharged'],
    },
    {
      kind: WidgetKind.table,
      title: 'Orders by carrier',
      dimensions: ['carrier'],
      metrics: ['orders', 'shippingCharged'],
    },
  ],
} as const satisfies Report;
